import React, { useContext } from "react";
import FundRequestsDuplicatesSection from "internal/components/Review/Sections/DuplicateFundRequests";
import { NotificationsContext } from "shared/util/context/notifications/NotificationsContext";
import { IGenericObject } from "shared/programs/migration-acceleration-program/2024/fund-request/types/CommonTypes";

const DuplicateDetails = ({ data }: { data: IGenericObject }) => {
  const { setNotifications } = useContext(NotificationsContext);

  const program = data?.program || "";
  const stage = data?.stage || "";
  const status = data?.status || "";

  return (
    <FundRequestsDuplicatesSection
      setNotificationsItems={setNotifications}
      program={program}
      stage={stage}
      status={status}
    />
  );
};

export default DuplicateDetails;
